<template>
  <page-layout class="live_reporting" v-if="reporting.idx">

    <div class="event_subj">
      <i><router-link to="/events">Live Events</router-link></i>
      <i class="event">
        <router-link :to="`${reporting.live_event.link_url}`" v-if="reporting.live_event.link_target === '_self'">{{reporting.live_event.title}}</router-link>
        <a :href="`${reporting.live_event.link_url}`" :target="reporting.live_event.link_target" v-else >{{reporting.live_event.title}}</a>
      </i>
      <!--<i>Live Reporting</i>-->
      <p class="subj">{{getReportingTitle}}</p>

      <!-- Mobile전용 상단 event 정보 -->
      <report-info :event-info="reporting.days.data[getCurrentDay].info"  v-if="isMobile" />

      <!-- menu tab -->
      <div class="tabs menu">
        <ul>
          <li v-for="(tab, i) in tabs" :key="i" :class="{on: currentTab === i}" @click="changeTab(i)">{{tab}}</li>
        </ul>
      </div>
    </div>

    <sub-page-layout no-border no-right-padding-top :event-info="getCurrentEventInfo">

      <div class="con_wrapper">

        <!-- day tab -->
        <div v-if="reporting.days.is_days">
          <div class="tabs days" v-if="currentTab === 0 || currentTab === 3">
            <ul>
              <li v-for="(day, i) in getDaysTabData" :key="i"
                  @click="changeDay(day.idx)"
                  :class="{on: day.idx === getCurrentDay}"
              >
                {{ day.title }}
              </li>
            </ul>
            <button v-if="currentTab === 0" class="sort" :class="isASC ? 'up' : 'down'" @click="changeSort()">Sort</button>
          </div>

          <!-- tab1 Live Updates Contents -->
          <div class="tab_con" id="articleList" v-if="currentTab === 0">

            <!-- report container 1 -->
            <div class="report" v-for="post in currentPosts" :key="post.idx">
              <!-- 제목 영역 -->
              <div class="data">
                <router-link :to="`/reporting/article/${post.idx}`" class="subj">{{post.title}}</router-link>
                <p class="date_area">
                  <i class="date">Posted {{post.pub_dt}} {{post.pub_tm}}</i>
                  <i class="level">{{post.level_info}}</i>
                </p>
              </div>
              <!-- 본문 영역 -->
              <div class="detail_con">
                <div class="con_view" v-html="post.contents">
                </div>
              </div>
              <!-- 태그 -->
              <div class="tag">
                <p class="h_tags">
                  <i class="tit">TAGs</i>
                  <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in post.tags" :key="`${post.idx}_${i}_${tag}`">{{tag}}</router-link>
                </p>
              </div>

            </div>
            <!--//report container 1 -->

          </div>
        </div>

        <!-- tab2 Payouts Contents -->
        <div class="tab_con" v-if="currentTab === 1">
          <div class="detail_con">
            <div class="con_view">

              <table v-if="reporting.payout.is_payout">
                <tbody>
                  <tr>
                    <td v-for="(col, cindex) in reporting.payout.data.header" :key="cindex">{{col.value}}</td>
                  </tr>
                  <tr v-for="(row, rindex) in reporting.payout.data.body" :key="rindex">
                    <td v-for="(col, cindex) in row" :key="cindex">
                      <div v-if="cindex === 0">
                        <span v-if="col.value">{{ col.value | comma }}</span>
                        <span v-else>{{ rindex + 1 }}<sup>{{convertOrdinalNumber(rindex + 1)}}</sup></span>
                      </div>
                      <div v-else>
                        <a v-if="col.link" :href="col.link" target="_blank">{{ col.value | comma }}</a>
                        <span v-else>
													<img v-if="reporting.payout.data.header[cindex].value.toLowerCase() === 'country' && col.value !== ''" class="flag" :src="`/statics/img/flags/${col.value}.svg`">
													<span v-else>{{ col.value | comma }}</span>
                      	</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <!-- tab3 Structure Contents -->
        <div class="tab_con" v-if="currentTab === 2">
          <div class="detail_con">
            <div class="con_view">

              <table v-if="reporting.structure.is_structure">
                <tbody>
                <tr>
                  <td v-for="(col, cindex) in reporting.structure.data.header" :key="cindex">{{col.value}}</td>
                </tr>
                <tr v-for="(row, rindex) in reporting.structure.data.body" :key="rindex">
                  <td v-for="(col, cindex) in row" :key="cindex">
                    <div v-if="cindex === 0">
                      <span v-if="col.value">{{ col.value | comma }}</span>
                      <span v-else>{{ rindex + 1 }}<sup>{{convertOrdinalNumber(rindex + 1)}}</sup></span>
                    </div>
                    <div v-else>
                      <a v-if="col.link" :href="col.link" target="_blank">{{ col.value | comma }}</a>
                      <span v-else>
                        <img v-if="reporting.structure.data.header[cindex].value.toLowerCase() === 'country' && col.value !== ''" class="flag" :src="`/statics/img/flags/${col.value}.svg`">
                        <span v-else>{{ col.value | comma }}</span>
                      </span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <!-- tab4 Chips Contents -->
        <div class="tab_con" v-if="currentTab === 3">
          <div class="detail_con">
            <div class="con_view">

              <table v-if="reporting.days.data[getCurrentDay].chips.is_chips">
                <tbody>
                <tr>
                  <td v-for="(col, cindex) in reporting.days.data[getCurrentDay].chips.data.header" :key="cindex">{{col.value}}</td>
                </tr>
                <tr v-for="(row, rindex) in reporting.days.data[getCurrentDay].chips.data.body" :key="rindex">
                  <td v-for="(col, cindex) in row" :key="cindex">
                    <div v-if="cindex === 0">
                      <span v-if="col.value">{{ col.value }}</span>
                      <span v-else>{{ rindex + 1 }}<sup>{{convertOrdinalNumber(rindex + 1)}}</sup></span>
                    </div>
                    <div v-else>
                      <a v-if="col.link" :href="col.link" target="_blank">{{ col.value }}</a>
                      <span v-else>
                        <img v-if="reporting.days.data[getCurrentDay].chips.data.header[cindex].value.toLowerCase() === 'country' && col.value !== ''" class="flag" :src="`/statics/img/flags/${col.value}.svg`">
                        <span v-else>{{ col.value }}</span>
                      </span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

      </div>

    </sub-page-layout>
  </page-layout>
</template>

<script>
  import PageLayout from '../layouts/PageLayout'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import ReportInfo from '../components/ReportInfo'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
	import {Dialog, Popover} from 'element-ui'
  import {QBtn, QBtnGroup, QSlideTransition, QDate, QCard, QSeparator} from 'quasar'
  const baseAction = '/live/reportings'
  export default {
    name: 'LiveReporting',
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      ReportInfo,
      QBtn, QBtnGroup, QCard, QDate, QSeparator,
      QSlideTransition,
      [Dialog.name]: Dialog,
      [Popover.name]: Popover,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | ${this.getReportingTitle}`,
        titleTemplate: '%s',
        meta: this.getSeoMeta
      }
    },
    data () {
      return {
        baseAction: baseAction,
        loaded: false,
        idx: '',
        reporting: {},
        currentPosts: [],
        is_mounted: false,
        currentTab: 0,
        currentDay: {
          live: 0,
          chips: 0,
        },
        tabs: ['Live Updates', 'Payouts', 'Structure', 'Chips'],
        isASC: false
      }
    },
		activated () {
      this.getReportingData()
    },
    deactivated() {
      this.reporting = {}
      this.currentPosts = []
    },
    beforeRouteUpdate (to, from, next) {
      if (from.params.idx !== to.params.idx) {
        next()
        this.updateViewCnt()
        this.getReportingData()
      } else if (from.query !== to.query) {
        next()
        const toQuery = this.cloneData(to.query)
        const fromQuery = this.cloneData(from.query)
        delete toQuery.sort
        delete fromQuery.sort
        if (fromQuery.toString() !== toQuery.toString()) this.updateViewCnt()
      } else {
        next(false)
      }
    },
    created() {
      this.updateViewCnt(true)
    },
    mounted () {
      this.is_mounted = true
    },
    computed: {
      ...CommonComputed,
      getReportingIdx () {
        return this.$route.params.idx
      },
			getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
		 	getReportingTitle () {
        return this.reporting && this.reporting.title ? this.reporting.title : ''
      },
      getSeoMeta () {
        return this.reporting ? this.reporting.seo_meta : []
      },
      getCurrentEventInfo () {
        return this.reporting.days.data[this.getCurrentDay] ? this.reporting.days.data[this.getCurrentDay].info : null
      },
      getDaysTabData () {
        const rtn =  this.reporting.days.data.map((row, i) => {
          row.idx = i
          return row
        }).filter(row => {
          return this.currentTab === 3 ? row.is_day && row.chips.is_chips : row.is_day
        }).reverse()

        return rtn
      },
      getCurrentDay () {
        return this.currentTab === 3 ? this.currentDay.chips : this.currentDay.live
      }
    },
    methods: {
      ...CommonMethods,
      getReportingData () {
        this.$axios.get(baseAction + '/' + this.getReportingIdx).then(rs => {

          this.reporting = rs.data

          this.applyRouteQuery()

          return true
        })
      },
      updateViewCnt (flag) {
        // view_cnt 업데이트
        if (flag || this.is_mounted) {
          this.$axios.put(baseAction + '/view_cnt/' + this.getReportingIdx).then(() => {
            console.log('updated view_cnt')
          })
        }
      },
      async getPostData () {
        if (this.currentTab !== 0) return
        if (this.reporting.days.data[this.getCurrentDay] && !this.reporting.days.data[this.getCurrentDay].is_day) return

        const params = {
          params: {
            liveReportingIdx: this.reporting.idx,
            liveReportingDay: this.getCurrentDay
          }
        }
        await this.$axios.get('/live/posts/search/fast', params).then(rs => {
          if (rs.data.total) {
            this.currentPosts = rs.data.data
            if (this.isASC) {
              this.currentPosts.sort((a, b) => a.idx - b.idx)
            }
          } else {
            this.currentPosts = []
          }
        })
      },
			toggleShareDialog (flag) {
        this.$store.dispatch('setOpenShareDialog', flag)
      },
      convertOrdinalNumber (n) {
        n = parseInt(n, 10)
        const suffix = ['th', 'st', 'nd', 'rd']
        const mod100 = n % 100
        return (suffix[(mod100-20)%10] || suffix[mod100] || suffix[0])
      },
      async applyRouteQuery () {

        const tab = this.$route.query.tab
        const day = this.$route.query.day
        const sort = this.$route.query.sort
        await this.changeTab(tab)
        await this.changeDay(day, true)

        if (sort && sort === 'ASC') {
          this.changeSort('DESC')
        }

        this.loaded = await true
      },
      async changeTab (index) {
        index = await this.checkRightTab(index)

        const query = this.cloneData(this.$route.query)
        this.currentTab = query.tab = index
        this.$router.replace({query: query})

        if (this.loaded && (this.currentTab === 0 || this.currentTab === 3)) {
          this.changeDay(this.getCurrentDay)
        }
      },
      async changeDay (idx, both = false) {

        idx = await this.checkRightDay(idx)

        await this.setCurrentDay(idx, both)
        await this.getPostData()
      },
      checkRightTab (index) {
        index = Number(index)
        if (typeof index !== 'number' || isNaN(index) || this.tabs.length <= Math.abs(index)) index = 0

        return index
      },
      checkRightDay (idx) {
        idx = Number(idx)
        const max = this.getDaysTabData.length > 0 ? this.getDaysTabData.reduce((a,b) => a > b ? b:a).idx : null
        if (typeof idx !== 'number' || isNaN(idx) || (max && max <= Math.abs(idx))) idx = max

        if (this.currentTab === 3 && max && !this.getDaysTabData.find(row => row.idx === idx).chips.is_chips) {
          const chk = this.getDaysTabData.findIndex(row => {
            return row.chips.is_chips
          })
          idx = chk > -1 ? this.getDaysTabData[chk].idx : this.getDaysTabData.length
        }

        return idx
      },
      setCurrentDay (idx, both = false) {
        if (both) {
          this.currentDay.chips = idx
          this.currentDay.live = idx
        } else {
          this.currentTab === 3 ? this.currentDay.chips = idx : this.currentDay.live = idx
        }
        const query = this.cloneData(this.$route.query)
        query.day = this.getCurrentDay
        this.$router.replace({query: query})
      },
      changeSort (sort = this.$route.query.sort) {
        sort = sort === 'ASC' ? 'DESC' : 'ASC'
        if (sort === 'ASC') {
          this.isASC = true
          this.currentPosts.sort((a, b) => a.idx - b.idx)
        } else {
          this.isASC = false
          this.currentPosts.sort((a, b) => b.idx - a.idx)
        }
        const query = this.cloneData(this.$route.query)
        query.sort = sort
        this.$router.replace({query: query})
      }
    }
  }
</script>

<style scoped>
  .event_subj {
    position: relative;
    max-width: 1220px;
    margin: 0 auto;
    border-bottom: 1px solid #ccc;
    letter-spacing: -0.025em;
  }
  .event_subj .subj {
    font-size: 42px;
    font-weight: 900;
    /* color: #008c03; */
    letter-spacing: -0.03em;
    margin: 10px 0;
  }
  .event_subj i {
    font-size: 16px;
    margin-right: 10px;
  }
  .event_subj i:after {
    content: ">";
    font-weight: 400;
    margin-left: 10px;
  }
  .event_subj i:nth-child(2):after {
    content: "";
  }
  .event_subj i.event {
    font-weight: 700;
  }
  .event_subj i a {
    color: #000;
  }
  .event_subj i a:hover {
    color: #008c03;
  }
  .con_wrapper {
    width: 700px;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .tabs.menu ul li {
    position: relative;
    display: inline-block;
    font-size: 20px;
    font-weight: 800;
    color: #777;
    margin: 0 25px;
    padding: 18px 0;
    cursor: pointer;
    transition: .15s;
  }
  .tabs.menu ul li:hover {
    color: #000;
  }
  .tabs.menu ul li.on {
    color: #008c03;
  }
  .tabs.menu ul li.on:hover {
    color: #008c03;
  }
  .tabs.menu ul li.on:after {
    content: "";
    display: inline-block;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    border-bottom: 3px solid #008c03;
  }
  .tabs.menu ul li:first-child {
    margin-left: 0;
  }
  .tabs.days {
    padding: 30px 0;
    border-bottom: 1px solid #ccc;
    position: relative;
  }
  .tabs.days ul {
    width: 90%;
    display: inline-block;
  }
  .tabs.days ul li {
    display: inline-block;
    font-size: 15px;
    font-weight: 900;
    color: #777;
    line-height: 1.0em;
    margin: 0 5px;
    padding: 10px 16px;
    border-radius: 5.0em;
    text-transform: capitalize;
    cursor: pointer;
  }
  .tabs.days ul li:hover {
    color: #000;
  }
  .tabs.days ul li.on {
    color: #fff;
    background: #008c03;
  }
  .tabs.days ul li:first-child {
    margin-left: 0;
  }
  .tabs.days .sort {
    display: inline-block;
    padding: 9px 15px 9px 38px;
    background: rgba(0,0,0,0.05);
    border-radius: 4px;
    font-weight: 600;
    color: #000;
    position: absolute;
    right: 0;
    cursor: pointer;
  }
  .tabs.days .sort:hover {
    background: rgba(0,0,0,0.1);
  }
  .tabs.days .sort:before {
    content: "";
    display: inline-block;
    width: 15px;
    height: 15px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translate(0, -50%);
  }
  .tabs.days .sort.up:before {
    background-image: url(/statics/img/align-justify-up.svg);
  }
  .tabs.days .sort.down:before {
    background-image: url(/statics/img/align-justify-down.svg);
  }
  .report {
    padding: 30px 0;
    border-bottom: 1px solid #ccc;
  }
  .report .data {
    position: relative;
  }
  .report .subj {
    font-size: 24px;
    font-weight: 900;
    color: #000;
    line-height: 1.4em;
    letter-spacing: -0.025em;
  }
  .report .subj:hover {
    color: #008c03;
  }
  .report .date_area {
    font-size: 14px;
    margin-top: 10px;
    font-weight: 500;
  }
  .report .date_area i {
    padding-right: 10px;
    color: #777;
  }
  .report .date_area .date:after {
    content: "/";
    color: #ccc;
    padding-left: 10px;
  }

  .detail_con {
    padding: 30px 0 0;
  }
  .detail_con .con_view {
    font-size: 16px;
    line-height: 1.9em;
    color: #000;
    word-break: break-all;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  .report .tag {
    position: relative;
    padding: 40px 0 0 50px;
  }
  .report .tag .h_tags  {
    font-size: 14px;
    font-weight: 500;
  }
  .report .tag .h_tags .tit {
    color: #000;
    font-weight: 700;
    position: absolute;
    left: 0;
  }
  .report .tag .h_tags a {
    display: inline-block;
    margin: 0 8px;
    color: #008c03;
  }
  .report .tag .h_tags a:hover {
    color: #000;
    border-color: #000;
  }
  .detail_con /deep/.ad_article {
    padding: 60px 20px 20px;
    background: #fff;
    display: inline-block;
    margin: 40px 0;
    position: relative;
  }
  .detail_con /deep/.ad_article img {
    width: 100%;
  }
  .detail_con /deep/.ad_article:before {
    content: "Advertisement";
    position: absolute;
    top: 15px;
    left: 20px;
    font-size: 0.9em;
    color: #333;
    line-height: 1.0em;
    padding: 7px 10px;
    border-radius: 5.0em;
    background: #f1f1f1;
  }
  .list_btn {
    display: block;
    text-align: center;
    width: 40%;
    padding: 15px 0;
    margin: 50px auto 0;
    font-size: 20px;
    color: #222;
    font-weight: 700;
    letter-spacing: -0.5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    transition: all 0.15s;
  }
  .list_btn:hover {
    color: #379339;
    border-color: #379339;
  }


  /* 콘텐츠 내 강제 지정 스타일 */
  /deep/ .con_view .card {
    font-size: 14px;
    font-weight: 900;
    padding: 0 3px;
    border: 1px solid #ccc;
    border-radius: 3px;
    background: #fff;
    margin: 2px;
  }
  /deep/ .con_view .card.black {
    color: #000;
  }
  /deep/ .con_view .card.red {
    color: #de0000;
  }
  /deep/ .con_view span a, /deep/ .con_view div a, /deep/ .con_view table a {
    color: #379339 !important;
    font-weight: 700;
    text-decoration: underline;
  }
  /deep/ .con_view span a img, .con_view div a img {
    background: #fff;
  }
  /deep/ .con_view span a:hover, /deep/ .con_view div a:hover, /deep/ .con_view table a:hover {
    color: #000 !important;
  }
  /deep/ .con_view span a u, .con_view div a u, .con_view a u {
    text-decoration: none !important;
  }
  /deep/ .con_view table {
    margin: 5px 0;
    width: 100%;
  }
  /deep/ .con_view table td {
    width: fit-content !important;
    padding: 16px 20px;
    background: #fff;
    font-size: 0.9em;
    font-weight: 500;
		vertical-align: middle;
    border-bottom: 1px solid #eee;
  }
  /deep/ .con_view table tr:first-child td {
    color: #379339;
    border-top: 1px solid rgba(55,147,57,0.35);
  }
  /deep/ .con_view table tr:nth-child(even) td {
    background: #fbfbfb;
  }
  /deep/ .con_view table tr td div {
    line-height: 1.0em;
  }
  /deep/ .con_view table .flag {
    position: relative;
    width: 24px;
    border: 1px solid rgba(0,0,0,0.75);
  }
  /deep/ .con_view p.box {
    display: block;
    font-size: 0.9em;
    padding: 20px 30px;
    line-height: 1.8em;
    background: #eee;
    border: none;
  }
  /deep/ .con_view a.btn_article {
    display: inline-block;
    width: 75%;
    padding: 14px;
    border-radius: 10px;
    background: #008c03;
    font-size: 1.3em;
    font-weight: 400;
    color: #fff !important;
    text-align: center;
    text-decoration: none;
    line-height: 1.4em;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
  }
  /deep/ .con_view a.btn_article:hover {
    color: #fff !important;
    background: #006702;
  }
  /deep/ .con_view a.btn_article:after {
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    border: solid #fff;
    border-width: 2px 2px 0 0;
    position: absolute;
    right: 8%;
    top: 50%;
    transform: rotate(45deg) translate(0, -75%);
  }
	/deep/ .con_view img {
    width: 100%;
	}
	/deep/ img[name^="target_resize_image[]"] {
		margin: 0 auto;
		display: block;
		max-width: 760px;
	}
	/deep/ .m-show {
		display: none;
	}
  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
  .p-hide {
    display: none;
  }
</style>
